/* LB Local Currency — display-only converter (GBP for UK visitors).
 * Checkout always charges USD (Shopify platform rule); this only localizes what shoppers SEE.
 * Safety model: converts ONLY strings matching the USD pattern ($X,XXX.XX) — converted text
 * can never re-match, so double-conversion is structurally impossible regardless of the
 * order this runs relative to litborne-summer26.js decorators.
 * Auto-sunset: goes inert the day real multi-currency presentment returns (Shopify Payments).
 */
(function () {
  'use strict';

  var GEO_ENABLED = true; /* live 2026-07-17 — GB visitors auto-see GBP estimates */
  var BUFFER = 1.02;       /* estimates stay slightly above the real USD charge */
  var FALLBACK_RATE = 0.74015; /* ECB 2026-07-16, used only if lb-fx.json unreachable */
  var SYM = '£';
  var USD_RX = /\$\s?(\d[\d,]*(?:\.\d{1,2})?)(?:\s*USD\b)?/g;

  var state = { rate: null, active: false, passScheduled: false };

  function init() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active !== 'USD') return; /* real presentment live — stand down */

    var param = null;
    try { param = new URLSearchParams(location.search).get('lb_cur'); } catch (e) {}
    if (param) { try { sessionStorage.setItem('lb_cur', param); } catch (e) {} }
    var pref = null;
    try { pref = sessionStorage.getItem('lb_cur'); } catch (e) {}

    if (pref === 'off' || pref === 'USD') return;
    var explicit = pref === 'GBP';

    /* bots keep USD so crawled prices match feeds/structured data — unless explicitly forced for testing */
    if (!explicit && /bot|crawler|spider|slurp|adsbot|lighthouse|headless/i.test(navigator.userAgent)) return;

    if (explicit) { start(); return; }
    if (!GEO_ENABLED) return;

    var geo = null;
    try { geo = sessionStorage.getItem('lb_geo'); } catch (e) {}
    if (geo === 'GB') { start(); return; }
    if (geo) return; /* known non-GB */
    fetch('/browsing_context_suggestions.json')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        try { sessionStorage.setItem('lb_geo', c || '??'); } catch (e) {}
        if (c === 'GB') start();
      })
      .catch(function () {});
  }

  function start() {
    loadRate(function (rate) {
      state.rate = rate * BUFFER;
      state.active = true;
      convertVmap();
      runPass();
      observe();
    });
  }

  function loadRate(cb) {
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem('lb_fx_v1')); } catch (e) {}
    if (cached && cached.rate > 0 && Date.now() - cached.ts < 864e5) { cb(cached.rate); return; }
    var tag = document.querySelector('script[src*="litborne-localcurrency"]');
    var url = tag && tag.getAttribute('data-fx');
    if (!url) { cb(FALLBACK_RATE); return; }
    fetch(url, { cache: 'no-cache' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var rate = j && j.gbp > 0 ? j.gbp : FALLBACK_RATE;
        try { localStorage.setItem('lb_fx_v1', JSON.stringify({ rate: rate, ts: Date.now() })); } catch (e) {}
        cb(rate);
      })
      .catch(function () { cb(FALLBACK_RATE); });
  }

  /* ---- money math ---- */

  function toGbp(usd) { return usd * state.rate; }

  function grid99(v) { var g = Math.ceil(v) - 0.01; if (g < v) g += 1; return g; }

  function fmt(v) {
    return SYM + v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function convertText(text, grid) {
    return text.replace(USD_RX, function (_, num) {
      var usd = parseFloat(num.replace(/,/g, ''));
      if (!isFinite(usd)) return _;
      var v = toGbp(usd);
      return fmt(grid ? grid99(v) : Math.round(v * 100) / 100);
    });
  }

  function convertEl(el, grid) {
    if (!el) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeValue && n.nodeValue.indexOf('$') !== -1) {
        var out = convertText(n.nodeValue, grid);
        if (out !== n.nodeValue) n.nodeValue = out;
      }
    }
  }

  /* ---- surfaces ---- */

  /* product page root fix: rewrite the vmap JSON so every variant-split write is already GBP */
  function convertVmap() {
    var vm = document.getElementById('lb-vmap');
    if (!vm || vm.dataset.lbCur) return;
    var j;
    try { j = JSON.parse(vm.textContent); } catch (e) { return; }
    var arr = Array.isArray(j) ? j : j && j.vars;
    if (!arr || !arr.length) return;
    arr.forEach(function (v) {
      if (typeof v.p === 'string' && v.p.indexOf('$') !== -1) {
        v.p = convertText(v.p, true);
        var full = parseFloat(v.p.replace(/[^\d.]/g, ''));
        if (isFinite(full)) v.ph = fmt(Math.round(full * 50) / 100);
        else if (typeof v.ph === 'string') v.ph = convertText(v.ph, false);
      }
    });
    vm.textContent = JSON.stringify(j);
    vm.dataset.lbCur = '1';
  }

  /* order matters: specific (grid) selectors first, broad plain containers last */
  var GRID_SEL = [
    '#lb-price', '#lb-price-compare', '#lb-cta-was',
    '#lb-variant-host .lb-var__price',
    '.lb-more__card-price',
    '.lb-poe-card__price',
    '.lb-s26-card__was', '.lb-s26-was',
    '[ref="priceContainer"]',
    '.lb-set__price s'
  ];
  var PLAIN_SEL = [
    '#lb-cta-today',
    '.lb-s26-card__new', '.lb-s26-new', '.lb-s26-saving-row',
    '.lb-set__price'
  ];
  var PLAIN_CONTAINERS = function () {
    var out = [];
    var d = document.querySelector('cart-drawer-component');
    if (d) out.push(d);
    if (location.pathname.indexOf('/cart') === 0) {
      var m = document.querySelector('main');
      if (m) out.push(m);
    }
    return out;
  };

  function runPass() {
    if (!state.active) return;
    convertVmap();
    var i, els, k;
    for (i = 0; i < GRID_SEL.length; i++) {
      els = document.querySelectorAll(GRID_SEL[i]);
      for (k = 0; k < els.length; k++) convertEl(els[k], true);
    }
    for (i = 0; i < PLAIN_SEL.length; i++) {
      els = document.querySelectorAll(PLAIN_SEL[i]);
      for (k = 0; k < els.length; k++) convertEl(els[k], false);
    }
    var cs = PLAIN_CONTAINERS();
    for (i = 0; i < cs.length; i++) convertEl(cs[i], false);
    placeNotes();
  }

  /* ---- checkout-shock disclaimers ---- */

  function noteEl(id) {
    var n = document.createElement('div');
    n.id = id;
    n.setAttribute('style', 'font-size:.72rem;opacity:.75;letter-spacing:.02em;margin:6px 0 2px;line-height:1.4;');
    n.textContent = 'Prices in ' + SYM + ' are estimates · You’ll be charged in USD at checkout';
    return n;
  }

  function placeNotes() {
    var box = document.querySelector('.lb-cta-box');
    if (box && !document.getElementById('lb-cur-note-p')) box.appendChild(noteEl('lb-cur-note-p'));
    var scopes = PLAIN_CONTAINERS();
    for (var i = 0; i < scopes.length; i++) {
      if (scopes[i].querySelector('[data-lb-cur-note]')) continue;
      var btn = scopes[i].querySelector('button[name="checkout"], a[href^="/checkout"], .cart__checkout-button');
      if (btn && btn.parentNode) {
        var n = noteEl('');
        n.removeAttribute('id');
        n.setAttribute('data-lb-cur-note', '1');
        n.style.textAlign = 'center';
        btn.parentNode.insertBefore(n, btn);
      }
    }
  }

  /* ---- keep converted through re-renders (AJAX cart, search, infinite scroll, s26 overlays) ---- */

  function schedule() {
    if (state.passScheduled) return;
    state.passScheduled = true;
    setTimeout(function () { state.passScheduled = false; runPass(); }, 120);
  }

  function observe() {
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    document.addEventListener('cart:update', schedule);
    document.addEventListener('DOMContentLoaded', schedule);
  }

  /* run last so every declaration above is initialized on the synchronous (warm-cache) path */
  try { init(); } catch (e) { /* fail closed: store stays exactly as-is */ }
})();
